import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { apiJson } from '../api';
import { Shell } from '../components/Shell';
import './ComparePage.css';

type CompareRow = { question: string; a: string; b: string };

export function ComparePage() {
  const { slug } = useParams();
  const [page, setPage] = useState<{
    title: string;
    summary: string | null;
    comparison_points_json: string;
    columns_json: string;
    content_json: string;
  } | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    if (!slug) return;
    let cancelled = false;
    (async () => {
      try {
        const res = await apiJson<{ page: Record<string, unknown> }>(`/api/compare/${slug}`);
        if (!cancelled) setPage(res.page as typeof page);
      } catch (e) {
        if (!cancelled) setErr(e instanceof Error ? e.message : 'Not found');
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [slug]);

  let rows: CompareRow[] = [];
  try {
    const cj = page?.content_json ? JSON.parse(page.content_json) : {};
    if (Array.isArray(cj.rows)) rows = cj.rows as CompareRow[];
  } catch {
    rows = [];
  }

  let columns: string[] = ['Islam', 'Other tradition'];
  try {
    columns = page?.columns_json ? JSON.parse(page.columns_json) : columns;
  } catch {
    /* ignore */
  }

  return (
    <Shell>
      <div className="wi-compare">
        {!page && !err ? <p className="muted">Loading…</p> : null}
        {err ? <p className="wi-compare-err">{err}</p> : null}
        {page ? (
          <>
            <header className="wi-compare-header">
              <p className="wi-compare-kicker">Structured comparison</p>
              <h1>{page.title}</h1>
              {page.summary ? <p className="wi-compare-lede">{page.summary}</p> : null}
              <p className="wi-compare-note">
                This is a study tool—not a debate arena. Definitions matter; read slowly and follow the linked modules
                for full context.
              </p>
            </header>
            <div className="wi-compare-table-wrap">
              <table className="wi-compare-table">
                <thead>
                  <tr>
                    <th>Question</th>
                    {columns.map((c) => (
                      <th key={c}>{c}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {rows.map((r, i) => (
                    <tr key={i}>
                      <td className="wi-compare-q">{r.question}</td>
                      <td>{r.a}</td>
                      <td>{r.b}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <section className="wi-compare-next">
              <h2>Continue in context</h2>
              <ul>
                <li>
                  <Link to="/journeys/christian-questions-about-islam">Journey that compares beliefs</Link>
                </li>
                <li>
                  <Link to="/journeys/christian-questions-about-islam">Christian questions journey</Link>
                </li>
                <li>
                  <Link to="/m/what-does-islam-say-about-jesus?from=compare">Module: Jesus in Islam</Link>
                </li>
              </ul>
            </section>
          </>
        ) : null}
      </div>
    </Shell>
  );
}
